import react from 'react';

export const withPage = (Component) => (params) => (
  <div className="page">
    <Component />
  </div>
);
